<div class="">
  <h1 class="text-2xl font-bold mb-4">Editar Proyecto</h1>

  <div class="flex items-center justify-center mb-8">
    <div class="flex w-full">
      <div class="flex w-1/3 text-center items-center">
        <div class="flex items-center justify-center w-10 h-10 bg-blue-500 rounded-full"
          [ngClass]="{'bg-gray-300': currentStep !== 1, 'bg-blue-500': currentStep === 1}">
          <span class="text-white"
            [ngClass]="{'text-gray-600': currentStep !== 1, 'text-white': currentStep === 1}">1</span>
        </div>
        <div class="mx-2">
          Datos básicos
        </div>

      </div>
      <div class="flex w-1/3 text-center items-center">
        <div class="flex items-center justify-center w-10 h-10 rounded-full"
          [ngClass]="{'bg-gray-300': currentStep !== 2, 'bg-blue-500': currentStep === 2}">
          <span [ngClass]="{'text-gray-600': currentStep !== 2, 'text-white': currentStep === 2}">2</span>
        </div>
        <div class="mx-2">
          Proyecciones
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="projectForm" (ngSubmit)="onSubmit()">

    <!-- STEP 1 -->
    <div *ngIf="currentStep === 1">

      <div class="mb-4">
        <label for="name" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Nombre</label>
        <input type="text" id="name" formControlName="name"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('name')?.invalid && projectForm.get('name')?.touched" class="text-red-500 text-sm">
          El nombre es obligatorio.
        </div>
      </div>

      <!-- Nemónico del Proyecto -->
      <div class="mb-4">
        <label for="projectId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Nemónico del Proyecto</label>
        <input type="text" id="projectId" formControlName="projectId" readonly
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('projectId')?.invalid && projectForm.get('projectId')?.touched"
          class="text-red-500 text-sm">
          El Nemónico es obligatorio.
        </div>
      </div>

      <!-- Tipo de Inscripción -->
      <!-- Selector de Moneda -->
      <div class="mb-4">
        <label for="currencyId" class="block text-gray-700 font-bold mb-2">Moneda del Proyecto</label>
        <select id="currencyId" formControlName="currencyId" (change)="onCurrencyChange()"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
          <option value="" disabled>Seleccione una moneda (dejar vacío para COP)</option>
          <option value="1">Peso Colombiano (COP) - Nacional</option>
          <option *ngFor="let currency of internationalCurrencies" [value]="currency.id">
            {{ currency.name }} ({{ currency.code }}) - Internacional
          </option>
        </select>
        <p class="text-sm text-gray-500 mt-1">
          Seleccione COP para proyectos nacionales o una moneda extranjera para proyectos internacionales
        </p>
        <div *ngIf="projectForm.get('currencyId')?.invalid && projectForm.get('currencyId')?.touched"
          class="text-red-500 text-sm">
          La moneda es obligatoria para proyectos internacionales.
        </div>
      </div>

      <!-- Monto de Inscripción en COP -->
      <div class="mb-4">
        <label for="inscriptionAmountCOP" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
          Monto de Inscripción en COP
        </label>
        <input type="text" appCurrencyFormatter id="inscriptionAmountCOP" formControlName="inscriptionAmountCOP"
          [readonly]="isInternationalProject(projectForm.get('currencyId')?.value)"
          [ngClass]="{'bg-gray-100': isInternationalProject(projectForm.get('currencyId')?.value)}"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <span class="text-sm text-gray-500">
          <span *ngIf="!isInternationalProject(projectForm.get('currencyId')?.value)">
            Ingrese el valor de inscripción en pesos colombianos
          </span>
          <span *ngIf="isInternationalProject(projectForm.get('currencyId')?.value) && currentExchangeRate">
            Calculado automáticamente: 1 {{ getSelectedCurrencyCode() }} = {{ formatExchangeRate(currentExchangeRate) }}
            COP
            <span class="text-xs text-gray-400">({{ lastRateUpdate | date:'short' }})</span>
          </span>
        </span>
        <div
          *ngIf="projectForm.get('inscriptionAmountCOP')?.invalid && projectForm.get('inscriptionAmountCOP')?.touched"
          class="text-red-500 text-sm">
          Monto de Inscripción en COP es obligatorio.
        </div>
      </div>

      <!-- Monto de Inscripción en USD (obligatorio) -->
      <div class="mb-4">
        <label for="inscriptionAmountUSD" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
          Monto de Inscripción en USD
        </label>
        <input type="text" appCurrencyFormatter id="inscriptionAmountUSD" formControlName="inscriptionAmountUSD"
          (input)="calculateCOPEquivalent()" class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <span class="text-sm text-gray-500">
          Valor en dólares estadounidenses. Si modifica este valor y tiene una moneda internacional seleccionada, se
          calculará automáticamente el equivalente en COP.
        </span>
        <div
          *ngIf="projectForm.get('inscriptionAmountUSD')?.invalid && projectForm.get('inscriptionAmountUSD')?.touched"
          class="text-red-500 text-sm">
          Monto de Inscripción en USD es obligatorio.
        </div>
      </div>

      <div class="mb-4">
        <label for="description" class="block text-gray-700 font-bold mb-2">Descripción</label>
        <textarea id="description" formControlName="description"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md"></textarea>
      </div>
      <div class="mb-4">
        <label for="period" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Período</label>
        <p-dropdown id="period" formControlName="period" [options]="months" optionLabel="label" optionValue="value"
          placeholder="Seleccione un mes" styleClass="w-full"
          inputStyleClass="w-full px-3 py-2 border border-neutral-300 rounded-md" [appendTo]="'body'">
        </p-dropdown>
        <div *ngIf="projectForm.get('period')?.invalid && projectForm.get('period')?.touched"
          class="text-red-500 text-sm">
          Período es obligatorio
        </div>
      </div>
      <div class="mb-4">
        <label for="status" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Estado</label>
        <select id="status" formControlName="status" class="w-full px-3 py-2 border border-neutral-300 rounded-md">
          <option value="" disabled>Seleccione un estado</option>
          <option *ngFor="let status of projectStatus" [value]="status.value">{{ status.label }}</option>
        </select>
        <div *ngIf="projectForm.get('status')?.invalid && projectForm.get('status')?.touched"
          class="text-red-500 text-sm">
          Estado es obligatoria
        </div>
      </div>

      <!-- Fecha de Inicio y Cierre -->
      <div class="mb-4">
        <label for="date" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Fecha de Inicio</label>
        <input type="date" id="date" formControlName="date"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('date')?.invalid && projectForm.get('date')?.touched" class="text-red-500 text-sm">
          Fecha de Inicio es obligatorio
        </div>
      </div>

      <div class="mb-4">
        <label for="dateClosed" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Fecha de Cierre</label>
        <input type="date" id="dateClosed" formControlName="dateClosed"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('dateClosed')?.invalid && projectForm.get('dateClosed')?.touched"
          class="text-red-500 text-sm">
          La Fecha de cierre es obligatorio.
        </div>
      </div>

      <div class="mb-4">
        <label for="typeProject" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Tipo de Proyecto</label>
        <select id="typeProject" formControlName="typeProject"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
          <option value="" disabled>Seleccione un tipo</option>
          <option *ngFor="let type of projectTypes" [value]="type.value">{{ type.label }}</option>
        </select>
        <div *ngIf="projectForm.get('typeProject')?.invalid && projectForm.get('typeProject')?.touched"
          class="text-red-500 text-sm">
          Tipo de proyecto es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="duration" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Duración en semanas</label>
        <input type="number" id="duration" formControlName="duration"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('duration')?.invalid && projectForm.get('duration')?.touched"
          class="text-red-500 text-sm">
          Duración en semanas es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="projectedParticipants" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Participantes
          Proyectados</label>
        <input type="number" id="projectedParticipants" formControlName="projectedParticipants"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div
          *ngIf="projectForm.get('projectedParticipants')?.invalid && projectForm.get('projectedParticipants')?.touched"
          class="text-red-500 text-sm">
          Participantes proyectados es obligatorio.
        </div>
      </div>
    </div>
    <!-- STEP 2 -->
    <div *ngIf="currentStep === 2">
      <div class="mb-4">
        <label for="observations" class="block text-gray-700 font-bold mb-2">Observaciones</label>
        <textarea id="observations" formControlName="observations"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md"></textarea>
      </div>

      <!-- Ingresos Proyectados -->
      <div class="mb-4">
        <label for="projectedRevenue" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Ingresos
          Proyectados</label>
        <input type="text" appCurrencyFormatter id="projectedRevenue" formControlName="projectedRevenue"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('projectedRevenue')?.invalid && projectForm.get('projectedRevenue')?.touched"
          class="text-red-500 text-sm">
          Los ingresos proyectados deben ser 0 o mayor.
        </div>
      </div>

      <!-- Gasto Proyectado -->
      <div class="mb-4">
        <label for="projectedSpend" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Gasto Proyectado</label>
        <input type="text" appCurrencyFormatter id="projectedSpend" formControlName="projectedSpend"
          class="w-full px-3 py-2 border border-neutral-300 rounded-md">
        <div *ngIf="projectForm.get('projectedSpend')?.invalid && projectForm.get('projectedSpend')?.touched"
          class="text-red-500 text-sm">
          El gasto proyectado debe ser 0 o mayor.
        </div>
      </div>

    </div>

    <!-- BUTTONS AREA -->
    <div class="flex justify-between mt-4">
      <!-- Botón Atrás -->
      <button type="button" *ngIf="currentStep > 1" class="bg-red-500 text-white px-4 py-2 rounded-md"
        (click)="prevStep()">
        Atrás
      </button>

      <!-- Botones Siguiente y Crear Proyecto -->
      <div class="flex ml-auto space-x-4">
        <!-- Botón Siguiente -->
        <button type="button" [disabled]="!isCurrentStepValid()" *ngIf="currentStep !== 2"
          class="bg-gray-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md" (click)="nextStep()">
          Siguiente
        </button>

        <!-- <button type="button"  (click)="openPreview()" [disabled]="!isCurrentStepValid()" *ngIf="currentStep === 3"class="bg-blue-500 text-white px-4 py-2 rounded-md">Vista Previa</button> -->

        <!-- Botón Crear Proyecto -->
        <button type="submit" [disabled]="!isCurrentStepValid()" *ngIf="currentStep === 2"
          class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md">
          Guardar Proyecto
        </button>
      </div>
    </div>

  </form>
</div>

<!-- <app-shared-modal [(isOpen)]="showPreview">  
    <app-preview-project [projectForm]="projectForm" [budgets]="budgets" (closeModal)="closePreview()"></app-preview-project>  
  </app-shared-modal> -->